export default __webpack_public_path__ + "static/media/Pokeball.8b2ee42b.png";